(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("gcodeViewer", [], factory);
	else if(typeof exports === 'object')
		exports["gcodeViewer"] = factory();
	else
		root["gcodeViewer"] = factory();
})(self, function() {
return 